<template>
  <div
    :class="{ 'mobile-expanded': mobileExpanded, simple: simple }"
    class="basket-component"
  >
    <div class="card">
      <div class="card-body">
        <div :class="{ 'mobile-toggle': !simple }">
          <h5 v-if="!simple">Extras Summary</h5>
          <h5 v-if="simple" class="mx-0 mb-4 mt-2">Your Customisation Summary</h5>

          <h6 v-if="basketIsEmpty" :class="{'text-dark': !simple, 'py-4': simple, 'mb-0': simple}"
              style="padding: 0 20px">
            Your basket is empty
          </h6>

          <ul :class="extrasExpanded ? 'mb-3' : ''">
            <li
              v-if="filteredBasketExtras.length > 0"
              class="
                d-flex
                align-items-center
                justify-content-between
                cursor-pointer
              "
              @click="extrasExpanded = !extrasExpanded"
            >
              <div class="d-flex align-items-center">
                <div v-show="extrasExpanded">
                  <i class="far fa-chevron-up me-3"></i>
                </div>
                <div v-show="!extrasExpanded">
                  <i class="far fa-chevron-down me-3"></i>
                </div>

                <span class="name">Step 1 Extras</span>
              </div>

              <span v-if="!isPreRes" class="ms-2 price font-weight-bolder"
              >&pound;{{ basket.eyesite_total | money }}</span
              >
            </li>
            <li
              v-for="extra in filteredBasketExtras"
              :key="extra.id"
              :class="{
                'd-flex': extrasExpanded,
                'd-none': !extrasExpanded,
                'align-items-center': !activeScreen,
              }"
              class="justify-content-between"
            >
              <a v-if="simple && extra.thumbnail_url" :href="extra.thumbnail_url"
                 title="Click to enlarge">
                <img
                  :alt="extra.name"
                  :src="extra.thumbnail_url"
                  class="me-3"
                  width="150"
                />
              </a>
              <span class="name me-2">
                {{ extra.room ? `${extra.room}: ` : "" }}{{ extra.type ? `${extra.type} - ` : "" }}{{
                  extra.name
                }}{{ extra.category ? ` (${extra.category})` : "" }}
                <small
                  v-if="simple && extra.description"
                  class="text-muted d-block"
                >{{ extra.description }}</small
                >
              </span>
              <span v-if="!isPreRes" class="ms-2 price font-weight-bolder"
              >&pound;{{ extra.price | money }}</span
              >
            </li>
          </ul>

          <ul>
            <li
              v-for="(item, productId) in basket.items"
              :key="productId"
              class="d-flex justify-content-between"
              :class="{ 'align-items-center': !activeScreen }"
            >
              <span class="name">
                {{ item.name }}<br>
                <span class="qty">Qty: {{ item.quantity }}</span>
              </span>
              <span v-if="!isPreRes" class="ms-2 price d-flex align-items-center">
                &pound;{{ item.line_total | money }}
                <span
                  class="ps-2 py-2 cursor-pointer"
                  @click="removeItem(productId)"
                >
                  <i class="far fa-trash ms-2 me-0 text-danger"></i>
                </span>
              </span>
              <span
                v-else
                class="ps-2 py-2 cursor-pointer"
                @click="removeItem(productId)"
              >
                <i class="far fa-trash ms-2 me-0 text-danger"></i>
              </span>
            </li>
          </ul>
        </div>

        <!-- Desktop -->
        <div
          v-if="!simple && !isPreRes"
          class="total d-none d-xl-flex justify-content-between"
        >
          <h5>Total:</h5>
          <h5>&pound;{{ basket.total | money }}</h5>
        </div>

        <!-- Mobile -->
        <div
          v-if="!simple"
          class="total d-xl-none text-dark"
          @click="mobileExpanded = !mobileExpanded"
        >
          <div class="d-flex align-items-center justify-content-between mb-4">
            <h4 class="mb-0">Extras Summary</h4>

            <div v-show="mobileExpanded">
              <i class="far fa-chevron-up me-3"></i>
            </div>
            <div v-show="!mobileExpanded">
              <i class="far fa-chevron-down me-3"></i>
            </div>
          </div>

          <div class="d-flex align-items-center justify-content-between">
            <h5 class="mb-0">Total:</h5>
            <h5 class="mb-0">&pound;{{ basket.total | money }}</h5>
          </div>
        </div>

        <a
          v-if="!simple"
          :href="basketUrl"
          class="
            btn
            btn-tertiary
            d-flex
            align-items-center
            justify-content-between
          "
          :class="{
            'p-3': activeScreen,
            'm-3': activeScreen,
          }"
          onclick="window.onbeforeunload = null;"
        >
          View basket
          <i class="far fa-shopping-basket"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      basket: null,
      mobileExpanded: false,
      extrasExpanded: false,
      basketUrl: window.basket_url,
    };
  },

  props: {
    preloadBasket: {
      type: Object,
      default: null,
    },
    rootBasket: {
      type: Object,
      default: null,
    },
    simple: {
      type: Boolean,
      default: false,
    },
    isPreRes: {
      type: Boolean,
      default: false,
    },
    activeScreen: {
      type: Boolean,
      default: false,
    },
    lockedInOrder: {
      type: Object,
      default: null,
    }
  },

  watch: {
    rootBasket: function (newValue, oldValue) {
      if (newValue) {
        this.basket = newValue;
      }
    },

    mobileExpanded: function (newValue, oldValue) {
      if (newValue) {
        $("body").addClass("modal-open");
      } else {
        $("body").removeClass("modal-open");
      }
    },
  },

  computed: {
    basketIsEmpty: function () {
      return (
        !this.basket ||
        (this.basket.items.length === 0 && this.basket.extras.length === 0)
      );
    },

    filteredBasketExtras: function () {
      return this.basket.extras.filter((extra) => {
        return !extra.esv_ignore_item;
      });
    },
  },

  created() {
    if (this.preloadBasket) {
      this.basket = this.$root.basket = this.preloadBasket;
    }
  },

  methods: {
    removeItem(productId) {
      this.loading = true;

      axios
        .post(`/api/v1/basket/remove_items`, {
          items: [
            {
              product_id: parseInt(productId),
            },
          ],
        })
        .then((res) => {
          if (res.data && res.data.success) {
            this.$root.basket = res.data.basket;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../sass/_admin-variables.scss";

.simple.active-screen {
  .card {
    box-shadow: none;

    .card-body {
      ul {
        display: grid;
        background-color: white;
        grid-template-columns: repeat(5, 1fr);
        gap: 20px;

        li {
          flex: 1;
          min-height: 200px;
          box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
          color: $castle-green;

          svg {
            &.fa-trash {
              width: .85vw !important;
              height: auto !important;
            }
          }
        }
      }
    }
  }
}
</style>
